import React, { useEffect, useRef } from "react";
import { t } from "i18next";
import ScriptInjector from "helpers/ScriptInjector";
import { logPopupError } from "utils/Utils";
import { brands, scriptSource } from "../helpers/utils";

const AfsWidgetLoader = ({ successPath = "", afsPaymentData = {},
  setIsLoading = () => {},
loading = false,
}) => {
  const applePayStyledRef = useRef(false); 
  const googlePayStyledRef = useRef(false);
  const observerRef = useRef(null); // store MutationObserver instance

  // Function to style Apple Pay button
  const styleApplePayButton = (button) => {
    if (!button || applePayStyledRef.current) return;

    if (!button.querySelector("span")) {
      const div = document.createElement("div");
      div.style.color = "rgb(230, 230, 230)";
      // span.textContent = t("Pay Apple Pay");
      // span.title = t("Apple Pay");
      div.innerHTML=`
      <svg width="120" height="19" viewBox="0 0 133 22" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M0 16.4402V2.34839H5.24414C8.00781 2.34839 9.92188 4.20386 9.92188 6.96753V6.98706C9.92188 9.74097 8.00781 11.6257 5.24414 11.6257H2.1875V16.4402H0ZM4.69727 4.19409H2.1875V9.78979H4.69727C6.60156 9.78979 7.69531 8.7644 7.69531 6.99683V6.97729C7.69531 5.21948 6.60156 4.19409 4.69727 4.19409ZM13.8293 16.6257C11.7785 16.6257 10.4016 15.366 10.4016 13.5203V13.5007C10.4016 11.7136 11.7883 10.6199 14.2199 10.4734L17.0129 10.3074V9.53589C17.0129 8.40308 16.2805 7.71948 14.9719 7.71948C13.7512 7.71948 12.9992 8.29565 12.8234 9.11597L12.8039 9.20386H10.8117L10.8215 9.09644C10.968 7.32886 12.5012 5.97144 15.0305 5.97144C17.5402 5.97144 19.132 7.29956 19.132 9.36011V16.4402H17.0129V14.8191H16.9738C16.3781 15.9226 15.1867 16.6257 13.8293 16.6257ZM12.5305 13.4714C12.5305 14.3699 13.2727 14.9363 14.4055 14.9363C15.8898 14.9363 17.0129 13.9304 17.0129 12.5925V11.7917L14.5031 11.948C13.2336 12.0261 12.5305 12.5828 12.5305 13.4519V13.4714ZM22.4242 19.8679C22.0141 19.8679 21.5746 19.8191 21.3207 19.7703V18.1199C21.4867 18.1589 21.7309 18.198 22.0141 18.198C23.0102 18.198 23.557 17.9343 23.9086 16.9382L24.0844 16.45L20.3441 6.16675H22.6293L25.2172 14.5261H25.2855L27.8734 6.16675H30.1L26.2719 16.9187C25.5102 19.0476 24.4359 19.8679 22.4242 19.8679ZM37.5145 16.4402L34.6922 6.16675H36.8016L38.6766 14.2527H38.7156L40.8543 6.16675H42.8855L45.034 14.2527H45.0828L46.9578 6.16675H49.0477L46.2352 16.4402H44.0379L41.8797 8.74487H41.8309L39.6922 16.4402H37.5145ZM51.5293 4.58472C50.8457 4.58472 50.2988 4.03784 50.2988 3.37378C50.2988 2.69995 50.8457 2.15308 51.5293 2.15308C52.2227 2.15308 52.7598 2.69995 52.7598 3.37378C52.7598 4.03784 52.2227 4.58472 51.5293 4.58472ZM50.4746 16.4402V6.16675H52.584V16.4402H50.4746ZM58.4152 16.6453C56.384 16.6453 55.4074 15.7859 55.4074 13.7351V7.84644H53.9328V6.16675H55.4074V3.49097H57.5656V6.16675H59.4895V7.84644H57.5656V13.6082C57.5656 14.6531 58.0344 14.9656 58.923 14.9656C59.1477 14.9656 59.3332 14.946 59.4895 14.9265V16.5574C59.2453 16.5964 58.8449 16.6453 58.4152 16.6453ZM61.3656 16.4402V2.34839H63.475V7.8562H63.5238C64.0707 6.66479 65.1742 5.97144 66.7074 5.97144C68.9047 5.97144 70.35 7.61206 70.35 10.0925V16.4402H68.2406V10.4929C68.2406 8.7937 67.3812 7.77808 65.8969 7.77808C64.4418 7.77808 63.475 8.89136 63.475 10.4929V16.4402H61.3656Z" fill="currentColor"/>
<path d="M88.3076 4.26758C88.813 4.26758 90.6211 4.3125 91.8003 6.03076C91.6992 6.10938 89.9023 7.12012 89.9023 9.38867C89.9023 12.0166 92.1934 12.9487 92.2607 12.9712C92.2495 13.0273 91.8901 14.2402 91.0591 15.4868C90.3066 16.5649 89.5093 17.6543 88.3076 17.6543C87.106 17.6543 86.7915 16.958 85.4214 16.958C84.0625 16.958 83.5796 17.6768 82.4902 17.6768C81.3897 17.6768 80.6147 16.666 79.75 15.4419C78.728 13.9707 77.897 11.7134 77.897 9.56836C77.897 6.14307 80.1318 4.3125 82.333 4.3125C83.4897 4.3125 84.4668 5.07617 85.1968 5.07617C85.8931 5.07617 86.9712 4.26758 88.3076 4.26758ZM87.6899 2.81885C87.0947 3.5376 86.084 4.07666 85.2866 4.07666C85.1968 4.07666 85.1069 4.06543 85.0508 4.0542C85.0396 4.00928 85.0171 3.86328 85.0171 3.72852C85.0171 2.81885 85.4888 1.90918 85.9829 1.33643C86.6231 0.583984 87.7012 0.0336914 88.5772 0C88.5996 0.101074 88.6108 0.224609 88.6108 0.348145C88.6108 1.25781 88.229 2.15625 87.6899 2.81885ZM96.6753 1.26904H103.211C106.446 1.26904 108.658 3.48145 108.658 6.74951C108.658 9.96143 106.367 12.1626 103.088 12.1626H99.5727V17.4746H96.6753V1.26904ZM99.5727 3.69482V9.75928H102.436C104.503 9.75928 105.716 8.68115 105.716 6.74951C105.716 4.76172 104.537 3.69482 102.448 3.69482H99.5727ZM114.095 15.4868C115.779 15.4868 117.037 14.3975 117.037 12.9712V11.9941L114.263 12.1738C112.702 12.2749 111.972 12.8364 111.972 13.8359C111.972 14.8691 112.859 15.4868 114.095 15.4868ZM113.275 17.6768C110.905 17.6768 109.209 16.2393 109.209 13.9932C109.209 11.7695 110.883 10.4893 113.87 10.3096L117.037 10.1187V9.08545C117.037 7.88379 116.228 7.20996 114.724 7.20996C113.443 7.20996 112.567 7.65918 112.309 8.49023H109.681C109.906 6.32275 111.938 4.94141 114.858 4.94141C118.014 4.94141 119.789 6.47998 119.789 9.08545V17.4746H117.104V15.79H116.914C116.228 16.9805 114.881 17.6768 113.275 17.6768ZM122.889 21.9331C122.721 21.9331 121.968 21.9219 121.788 21.8882V19.6084C121.946 19.6421 122.361 19.6533 122.552 19.6533C123.731 19.6533 124.394 19.2041 124.753 18.0698L124.899 17.5308L120.508 5.18848H123.563L126.438 14.7793H126.629L129.493 5.18848H132.435L127.999 17.8677C126.954 20.9224 125.641 21.9331 122.889 21.9331Z" fill="currentColor"/>
</svg>


`
      button.appendChild(div);
    }

    applePayStyledRef.current = true; // mark as styled
  };

  const styleGooglePayButton = (button) => {
    if (!button || googlePayStyledRef.current) return;
    if (!button.querySelector("span")) {
      const span = document.createElement("span");
      span.textContent = t("Pay Google Pay");
      span.title = t("Google Pay");
      button.appendChild(span);
    }
    googlePayStyledRef.current = true; // mark as styled
  };

  useEffect(() => {
    // Return early if no payment data
    if (!afsPaymentData?.id || !afsPaymentData?.integrity) return;

    // Watch for DOM changes
    observerRef.current = new MutationObserver(() => {
      const button = document.querySelector(".wpwl-apple-pay-button");
      if (button) {
        styleApplePayButton(button);
      }
      // const googlePayButton = document.getElementById("gpay-button-online-api-id");
      // if (googlePayButton) {
      //   styleGooglePayButton(googlePayButton);
      // }
      const cardContainer = document.querySelector(".wpwl-container-card");
      if (cardContainer) {
        setIsLoading(false);
      }
    });

    // Start observing the whole document
    observerRef.current.observe(document.body, {
      childList: true,
      subtree: true,
    });

    // Cleanup on unmount
    return () => {
      if (observerRef.current) observerRef.current.disconnect();
    };
  }, [afsPaymentData]);

  if (!successPath || !afsPaymentData?.id) return null;

  return (
    <>
      <form
        action={successPath}
        className="paymentWidgets"
        data-brands={brands}
      ></form>

      {afsPaymentData?.id && afsPaymentData?.integrity && (
        <ScriptInjector
          scriptSrc={`${scriptSource}${afsPaymentData.id}`}
          scriptProps={{
            id: "afs-script",
            crossOrigin: "anonymous",
            integrity: afsPaymentData.integrity,
          }}
          onLoad={() => {
            console.log("AFS script loaded ✅");
            const button = document.querySelector(".wpwl-apple-pay-button");
            if (button) styleApplePayButton(button); // style immediately if already present
          }}
          onError={(error) => {
            logPopupError(
              error?.message || "Something went wrong. Please try again later.",
              true
            )
            setIsLoading(false);
          }}
        />
      )}
    </>
  );
};

export default AfsWidgetLoader;
